module.exports = __webpack_public_path__ + "img/case17.eabc973c.png";